import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-pdf-resolver',
  standalone: true,
  template: '',
})
export class PdfResolverComponent {

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) {
    //console.log('PdfResolverComponent constructor())');
        
    const fileName = this.route.snapshot.paramMap.get('fileName');
    const routePath = this.route.snapshot.routeConfig?.path;
    
    //console.log('fileName: ' + fileName);
    //console.log('routePath: ' + routePath);
    
    if (!fileName || !routePath) {
      this.router.navigate(['/page-not-found']);
      return;
    }

    // 🔹 regolamenti → assets/regolamenti
    if (routePath.startsWith('regolamenti')) {
      //console.log('inside if regolamenti: ' + routePath);
      window.location.href = `/assets/regolamenti/${fileName}`;
      return;
    }

    // 🔹 scheda-tecnica → assets/scheda_tecnica
    if (routePath.startsWith('scheda_tecnica')) {
      //console.log('inside if scheda_tecnica: ' + routePath);      
      window.location.href = `/assets/scheda_tecnica/${fileName}`;
      return;
    }

    this.router.navigate(['/page-not-found']);
  }
}
